import { invoke } from '@forge/bridge';

class LicenseApi {

    getIsLicenseActive(): Promise<boolean> {
        return invoke('is-license-active');
    }
}

export default new LicenseApi();
